<script setup lang="ts">
import Section from 'gpcore-uikit/components/Component.Section.vue';
import ProgressStateIcon from '@panel/components/app/ProgressStateIcon.vue';
import WelcomeSectionBody from './WelcomeSectionBody.vue';

const { name, isDone = false } = defineProps<{
  name: string;
  isDone?: boolean;
}>();

defineSlots<{
  default: () => void;
  content: () => void;
  footer: () => void;
}>();
</script>

<template>
  <Section class="tw-flex tw-min-h-[32rem] tw-flex-col tw-justify-between">
    <div class="tw-mb-4 tw-flex tw-h-auto tw-items-center tw-gap-4">
      <ProgressStateIcon :is-done="isDone" />
      <h3>
        {{ name }}
      </h3>
    </div>

    <slot>
      <WelcomeSectionBody>
        <template #default>
          <slot name="content"></slot>
        </template>

        <template #footer>
          <slot name="footer"></slot>
        </template>
      </WelcomeSectionBody>
    </slot>
  </Section>
</template>

<style scoped></style>
